import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

const MediaRowLevelSchema = z.object({
  id: z.string(),
  name: z.string(),
});

const PlatformLevelSchema = z.object({
  label: z.string(),
  name: z.string(),
  children: z.array(MediaRowLevelSchema),
  //isGhost field will be removed in response after mdm platforms release
  isGhost: z.boolean().optional(),
  //logo field probably will be added in response in the future
  logo: z.string().optional().nullable(),
});

const ActivityLevelSchema = z.object({
  id: z.string(),
  name: z.string(),
  children: z.array(PlatformLevelSchema),
});

export const GetRowsResponseSchema = createResponseSchema(ActivityLevelSchema);
